import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    difficultyBtn: {
      height: 29,
      maxWidth: 28,
      minWidth: 28,
    },
    difIconWrap: {
      height: 29,
      width: 29,
      borderRadius: 5,
      background: colorsPalette.blue,
      boxSizing: 'border-box',
    },
    difIcon: {
      width: '100%',
      height: '100%',
      padding: 7,
    },
  }),
);

export default useStyles;
